<div id="content">
  <div class="page-title sticky d-flex align-items-center justify-content-between flex-wrap mb-4">
    <h1 class="mb-0">
      <a class="page-title-root" routerLink="/employees/rrhh/surveys">Encuestas</a>
      @if (breadcrumb_survey_title(); as survey_title) {
        <span class="page-title-separator">/</span>
        <a class="page-title-crumb" [routerLink]="survey_edit_link()" [attr.title]="survey_title">{{ survey_title }}</a>
      }
      @if (breadcrumb_section_title(); as section_title) {
        <span class="page-title-separator">/</span>
        <span class="page-title-crumb" [attr.title]="section_title">{{ section_title }}</span>
      }
    </h1>
    <div class="page-actions d-flex gap-2">
      <button mat-flat-button color="accent" type="button" [disabled]="loading() || loading_data()" (click)="save()">
        <mat-icon class="survey-section-edit-save-icon">save</mat-icon>
        Guardar
      </button>
    </div>
  </div>

  @if (loading_data()) {
    <p>Cargando...</p>
  } @else if (section()) {
    <div class="survey-section-edit-layout">
      <form
        class="survey-section-edit-card"
        [class.survey-section-edit-card--collapsed]="!config_expanded()"
        [formGroup]="form"
        (ngSubmit)="save()"
      >
        <button
          class="survey-section-edit-card__toggle"
          type="button"
          [attr.aria-expanded]="config_expanded()"
          (click)="config_expanded.set(!config_expanded())"
        >
          <h2 class="survey-section-edit-card__title">Configuración de sección</h2>
          <mat-icon aria-hidden="true">{{ config_expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        @if (config_expanded()) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre de la sección</mat-label>
            <input matInput formControlName="title" />
            @if (form.controls.title.hasError('required')) {
              <mat-error>El nombre es obligatorio</mat-error>
            }
          </mat-form-field>
        }
      </form>

      <section class="survey-section-scope-card" [class.survey-section-scope-card--collapsed]="!scope_expanded()">
        <button
          class="survey-section-scope-card__toggle"
          type="button"
          [attr.aria-expanded]="scope_expanded()"
          (click)="scope_expanded.set(!scope_expanded())"
        >
          <div class="survey-section-scope-card__heading">
            <h2 class="survey-section-scope-card__title">Configuración de Alcance</h2>
            @if (scope_expanded()) {
              <p class="survey-section-scope-card__subtitle">Esta configuración se heredará a todas las preguntas de la sección</p>
            }
          </div>
          <mat-icon aria-hidden="true">{{ scope_expanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        @if (scope_expanded()) {
          <div class="survey-section-scope-card__blocks">
            <div class="survey-section-audience-group">
              <app-targeted-roles-card
                title="1. A quién preguntar (Roles)"
                description="Define qué roles recibirán esta sección"
                all_label="Todos los roles"
                [embedded]="true"
                [options]="roles()"
                [selection]="form.controls.role_ids.value"
                [error_message]="roles_error()"
                (selectionChange)="onRoleIdsChange($event)"
              />

              @if (worker_role_selected()) {
                <app-targeted-department-categories-card
                  class="survey-section-audience-group__department-categories"
                  title="Categorías de departamento"
                  description="Filtra por categorías de departamento del rol worker"
                  [embedded]="true"
                  [options]="department_category_options()"
                  [selection]="form.controls.department_category_ids.value"
                  [error_message]="department_categories_error()"
                  (selectionChange)="onDepartmentCategoryIdsChange($event)"
                />
              }
            </div>

            <app-targeted-company-products-card
              title="2. Sobre qué productos"
              description="Define el alcance de productos para las preguntas"
              [embedded]="true"
              [scope]="form.controls.company_product_scope_type.value"
              [selection]="form.controls.company_products.value"
              [error_message]="company_products_error()"
              (scopeChange)="onCompanyProductScopeChange($event)"
              (selectionChange)="onCompanyProductsChange($event)"
              (products_blur)="onCompanyProductsBlur()"
            />

            <app-targeted-users-card
              title="3. Sobre qué usuarios"
              description="Define el alcance de usuarios para las preguntas"
              [embedded]="true"
              [scope]="form.controls.users_scope_type.value"
              [selection]="form.controls.users.value"
              [error_message]="users_error()"
              (scopeChange)="onUsersScopeChange($event)"
              (selectionChange)="onUsersChange($event)"
              (users_blur)="onUsersBlur()"
            />
          </div>
        }
      </section>

      <section class="survey-section-edit-card">
        <div class="survey-section-edit-questions__header">
          <h2 class="survey-section-edit-card__title">Preguntas</h2>
          <button mat-stroked-button type="button" [disabled]="loading() || loading_data()" (click)="addQuestion()">
            <mat-icon class="survey-section-edit-save-icon">add</mat-icon>
            Añadir
          </button>
        </div>

        @if (form.controls.questions.length > 0) {
          <div
            class="survey-section-edit-questions__list"
            cdkDropList
            [cdkDropListDisabled]="loading() || loading_data()"
            (cdkDropListDropped)="dropQuestion($event)"
          >
            @for (
              question_form of form.controls.questions.controls;
              track question_form.controls.form_key.value;
              let question_index = $index
            ) {
              <div class="survey-section-edit-question" cdkDrag [cdkDragDisabled]="loading() || loading_data()">
                <app-survey-section-question-edit
                  [question_form]="question_form"
                  [question_index]="question_index"
                  [disabled]="loading() || loading_data()"
                  (remove)="removeQuestion(question_index)"
                />
              </div>
            }
          </div>
        }
      </section>
    </div>
  }
</div>
